import React, { useEffect, useState } from 'react';

import { isIndiaSelected, isFirstVisit, setVisited } from 'shared/helpers/utils/internationalShipping';
import InfoModal from './infoModal';


interface FirstVisitProps {
  internationalMode: boolean;
}


const FirstVisitInfo = ({ internationalMode }: FirstVisitProps) => {
  const [showFirstVisit, setFirstVisit] = useState(false);
  useEffect(() => {
    if (internationalMode && (isFirstVisit()) && (!isIndiaSelected())) {
      setFirstVisit(true);
      setTimeout(() => { setVisited(); }, 800);
    }
  }, [internationalMode]);
  if (!showFirstVisit || (isIndiaSelected())) {
    return null;
  }
  return (
    <InfoModal onClose={() => setFirstVisit(false)} />
  );
};
export default FirstVisitInfo;
